import { ImpactModule } from 'types'

export const APP_CITIZEN_MODULE: ImpactModule = {
  NAME: 'APP_CITIZEN',
  NAME_PTBR: 'App Cidadão',
  UPPER_NAME: 'APP_CITIZEN',
  API_NAME: 'ACCOUNT',
}
